import { render, staticRenderFns } from "./DialogArquivosBackup.vue?vue&type=template&id=5804509a&scoped=true&"
import script from "./DialogArquivosBackup.vue?vue&type=script&lang=js&"
export * from "./DialogArquivosBackup.vue?vue&type=script&lang=js&"
import style0 from "./DialogArquivosBackup.vue?vue&type=style&index=0&id=5804509a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804509a",
  null
  
)

export default component.exports